import * as Sentry from "@sentry/react";
import { env } from "./env";

export function initSentry() {
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Strip PII potentielle (téléphones, emails dans les exceptions)
      if (event.exception?.values) {
        for (const v of event.exception.values) {
          if (v.value) {
            v.value = v.value.replace(/\+?\d{8,15}/g, "[phone]");
            v.value = v.value.replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, "[email]");
          }
        }
      }
      return event;
    },
  });
}

export const captureException = Sentry.captureException;
export const captureMessage = Sentry.captureMessage;
export const SentryErrorBoundary = Sentry.ErrorBoundary;
